import { Column } from '@tanstack/react-table';
import { CSSProperties } from 'react';

const DEFAULT_ITEM_SIZE = 30;

// Cache to avoid repeated DOM measurements
const heightCache = new WeakMap<HTMLElement, number>();

export const itemSizeDefault = (el: HTMLElement) => {
  // Check cache first to avoid repeated DOM measurements
  if (heightCache.has(el)) {
    return heightCache.get(el)!;
  }

  const height = el.getBoundingClientRect().height || DEFAULT_ITEM_SIZE;
  heightCache.set(el, height);
  return height;
};

export const getCommonPinningStyles = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  column: Column<any, unknown>
): CSSProperties => {
  const isPinned = column.getIsPinned();
  return {
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    position: isPinned ? 'sticky' : 'relative',
    zIndex: 0,
    background: isPinned ? 'inherit' : undefined,
  };
};
